import { render } from "./ForgotPasswordConfirmView.vue?vue&type=template&id=49ab16d2&scoped=true"
import script from "./ForgotPasswordConfirmView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordConfirmView.vue?vue&type=script&lang=js"

import "./ForgotPasswordConfirmView.vue?vue&type=style&index=0&id=49ab16d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab16d2"]])

export default __exports__